"use strict";
export const imageSizes = {
  image12: 12,
  image16: 16,
  image20: 20,
  image24: 24,
  image32: 32,
  image36: 36,
  image40: 40,
  image48: 48,
  image64: 64,
  image100: 100
};
